import { render, staticRenderFns } from "./InfosCard.vue?vue&type=template&id=cfafd762&scoped=true&"
import script from "./InfosCard.vue?vue&type=script&lang=js&"
export * from "./InfosCard.vue?vue&type=script&lang=js&"
import style0 from "./InfosCard.vue?vue&type=style&index=0&id=cfafd762&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfafd762",
  null
  
)

export default component.exports